const route = {
	name: 'rating',
	path: 'rating',
	meta: {
		title: 'VALORACIÓN',
	},
	component: () => import('@/pages/ecommerce/page-rating'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/rating.js